import React, { useEffect, useState } from "react";
import imageCompression from "browser-image-compression";
import TextareaAutosize from "react-textarea-autosize";
import { useHistory } from "react-router-dom";

// @ts-ignore
import Select from "react-select";
// @ts-ignore
import DatePicker from "react-datepicker";
// @ts-ignore
import SweetAlert from "sweetalert2-react";
// @ts-ignore
import { format, parseISO } from "date-fns";

import { api } from "@shared/api";
import { numeric } from "@shared/functions";
import { optionCompressImage } from "@shared/constants";
import { Ads } from "@store/service/models";
import { useUpdateAdsMutation } from "@store/service/apis";

import styles from "./edit.module.css";
import "react-datepicker/dist/react-datepicker.css";

const EditAdsForm = (props: any) => {
  // const [user, setUser] = useState<any>();
  const [ads, setAds] = useState<Ads>();
  // const [adsID, setAdsID] = useState<any>();
  const [optionAdsType, setOptionAdsType] = useState<any>();
  const [adsType, setAdsType] = useState<any>();
  const [adsTypeID, setAdsTypeID] = useState<any>();
  const [isAdsTypeError, setIsAdsTypeError] = useState(false);
  const [title, setTitle] = useState<any>();
  const [isTitleError, setIsTitleError] = useState(false);
  const [url, setUrl] = useState<any>();
  const [price, setPrice] = useState<any>();
  const [isActive, setIsActive] = useState("0");
  const [marketing, setMarketing] = useState<any>();
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  const [img, setImg] = useState<any>();
  const [reviewImg, setReviewImg] = useState<any>();
  const [isSuccessSave, setIsSuccessSave] = useState(false);
  const [labelSubmit, setLabelSubmit] = useState("Simpan Iklan");
  const [optionAdvList, setOptionAdvList] = useState<any>([
    { label: "Pilih kanal Advertorial", value: "" },
  ]);
  const [advList, setAdvList] = useState<any>();

  const history = useHistory();

  useEffect(() => {
    api
      .get(`admin/ads-type/for-form`)
      .then((res) => setOptionAdsType(res.data.data));
    api.get(`admin/adv-list`).then((res) => {
      const temp = Array.from(new Set([...optionAdvList, ...res.data.data]));
      setOptionAdvList(temp);
    });
    // const authUser = auth.user() || "";
    // if (authUser) setUser(JSON.parse(authUser));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props !== undefined) {
      setAds(props.ads);
      // setAdsID(props.adsID);
    }
  }, [props]);

  useEffect(() => {
    if (ads) {
      setTitle(ads.title || "");
      setAdsType(ads.ads_type_id || 0);
      setUrl(ads.url || "");
      setPrice(ads.price || "");
      setStartDate(ads.start_date ? parseISO(ads.start_date) : "");
      setEndDate(ads.end_date ? parseISO(ads.end_date) : "");
      setMarketing(ads.marketing || "");
      setIsActive(ads.is_active?.toString() || "0");
      setReviewImg(ads.img_thumb);
    }
  }, [ads]);

  useEffect(() => {
    if (title === null) {
      setIsTitleError(false);
    } else if (title?.length === 0) {
      setIsTitleError(true);
    } else {
      setIsTitleError(false);
    }
  }, [title]);

  useEffect(() => {
    if (adsType !== null) {
      setAdsTypeID(adsType?.id || 0);
    }
  }, [adsType]);

  const handleGetImg = async (e: any) => {
    const imageFile = e.target.files[0];
    try {
      const compressedFile = await imageCompression(
        imageFile,
        optionCompressImage
      );
      const imgBase64 = getBase64(compressedFile);
      setImg(imgBase64);
      setReviewImg(imgBase64);
    } catch (error) {
      console.log(error);
    }
  };

  const getBase64 = (file: any) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setImg(reader.result);
      setReviewImg(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const getValueAdv = () =>
    optionAdvList?.find((el: any) => el?.value === ads?.category_id);

  const [updateAds] = useUpdateAdsMutation();

  const handleSave = () => {
    setLabelSubmit("Loading...");
    setIsTitleError(false);
    if (!title) {
      setIsTitleError(true);
      setLabelSubmit("Update Iklan");
      return;
    }

    const payload = {
      ads_type_id: adsTypeID,
      category_id: advList ? advList.value : getValueAdv()?.value,
      title,
      url,
      price: price ? +price : 0,
      start_date: startDate ? format(startDate, "yyyy-MM-dd") : "",
      end_date: endDate ? format(endDate, "yyyy-MM-dd") : "",
      is_active: isActive,
      marketing,
      image: img,
    };
    try {
      updateAds({ id: ads?.id, ...payload })
        .unwrap()
        .then(() => {
          setIsSuccessSave(true);
          history.goBack();
        });
    } catch (error) {
      setIsSuccessSave(false);
    }
    // api
    //   .put(`admin/ads/${adsID}`, data, {
    //     headers: { Authorization: `Bearer ${user.access_token}` },
    //   })
    //   .then(() => {
    //     setIsSuccessSave(true);
    //     history.goBack();
    //   })
    //   .catch(() => {
    //     setIsSuccessSave(false);
    //   });
    setLabelSubmit("Update Iklan");
  };

  return (
    <>
      <div className={styles.wrapForm}>
        <div>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right">
              Jenis Iklan
            </label>
            <div className="col-sm-9">
              <Select
                value={optionAdsType?.find((el: any) => +el?.id === +adsType)}
                placeholder="Pilih jenis iklan"
                onChange={(e: any) => {
                  setAdsType(e);
                  setIsAdsTypeError(false);
                }}
                options={optionAdsType}
              />
              {isAdsTypeError && (
                <p className={styles.messageError}>
                  Kategori berita jangan dikosongkan!
                </p>
              )}
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right">
              Kanal Advertorial
            </label>
            <div className="col-sm-9">
              <Select
                value={
                  advList
                    ? advList
                    : ads?.category_id &&
                      optionAdvList?.find(
                        (el: any) => el?.value === ads?.category_id
                      )
                }
                placeholder="Pilih kanal advertorial"
                onChange={(e: any) => {
                  setAdvList(e);
                }}
                options={optionAdvList}
              />
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right">
              Title Iklan
            </label>
            <div className="col-sm-9">
              <TextareaAutosize
                defaultValue={title}
                className={"form-control " + styles.inputForm2}
                onKeyUp={(e: any) => {
                  setTitle(e.target.value);
                  if (e.target.value.length > 0) {
                    setIsTitleError(false);
                  } else {
                    setIsTitleError(true);
                  }
                }}
                placeholder={"Tulis title iklan disini"}
                maxLength={255}
              />
              {isTitleError && (
                <p className={styles.messageError}>
                  Title iklan jangan dikosongkan!
                </p>
              )}
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right">
              URL Iklan
            </label>
            <div className="col-sm-9">
              <TextareaAutosize
                defaultValue={ads?.url}
                className={"form-control " + styles.inputForm2}
                onKeyUp={(e: any) => {
                  setUrl(e.target.value);
                }}
                placeholder={
                  "URL iklan disini, lengkap dengan http atau https. Misal: https://kukarkab.co.id"
                }
                maxLength={255}
              />
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right">
              Harga Iklan
            </label>
            <div className="col-sm-9">
              <TextareaAutosize
                value={price}
                className={"form-control " + styles.inputForm2}
                onKeyUp={(e: any) => {
                  setPrice(e.target.value);
                }}
                placeholder={
                  "Harga iklan tulis disini (memudahkan proses rekapitulasi)"
                }
                maxLength={255}
                onKeyPress={(e: any) => {
                  numeric(e);
                }}
              />
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right">
              Tanggal Mulai
            </label>
            <div className="col-sm-9">
              <DatePicker
                className={"form-control " + styles.inputForm2}
                selected={startDate}
                value={startDate}
                onChange={(e: any) => {
                  setStartDate(e);
                }}
                type="text"
                dateFormat="yyyy-MM-dd"
              />
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right">
              Tanggal Selesai
            </label>
            <div className="col-sm-9">
              <DatePicker
                className={"form-control " + styles.inputForm2}
                selected={endDate}
                value={endDate}
                onChange={(e: any) => setEndDate(e)}
                type="text"
                dateFormat="yyyy-MM-dd"
              />
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right">
              Nama Marketing
            </label>
            <div className="col-sm-9">
              <TextareaAutosize
                value={marketing}
                className={"form-control " + styles.inputForm2}
                onKeyUp={(e: any) => {
                  setMarketing(e.target.value);
                }}
                placeholder={"Tuliskan nama marketing"}
                maxLength={255}
              />
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right">Gambar</label>
            <div className="col-sm-9">
              {reviewImg && (
                <div style={{ position: "relative" }}>
                  <img src={reviewImg} className={styles.reviewImg} alt="img" />
                  <button
                    className={"btn btn-danger " + styles.btnDeleteImg}
                    onClick={() => {
                      setImg("");
                      setReviewImg("");
                    }}
                  >
                    Hapus Gambar
                  </button>
                </div>
              )}
              <input id="file" type="file" onChange={(e) => handleGetImg(e)} />
              <label htmlFor="file">Sisipkan Gambar</label>
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3  col-form-label text-right">
              Status
            </label>
            <div className="col-sm-9">
              <span className={"mx-3"}>
                <input
                  className={styles.radio}
                  type="radio"
                  id="is_active"
                  value={1}
                  checked={isActive === "1"}
                  onChange={() => {
                    setIsActive("1");
                  }}
                />
                <label htmlFor="is_active">Aktif</label>
              </span>
              <span className={"mx-3"}>
                <input
                  className={styles.radio}
                  type="radio"
                  id="is_active_n"
                  value={0}
                  checked={isActive === "0"}
                  onChange={() => {
                    setIsActive("0");
                  }}
                />
                <label htmlFor="is_active_n">Tidak Aktif</label>
              </span>
            </div>
          </div>
        </div>
        <div className={"mt-2"}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label text-right"></label>
            <div className="col-sm-9">
              <button
                type="button"
                className={`btn ${styles.btnCancel}`}
                onClick={() => history.goBack()}
              >
                Back
              </button>
              <button
                type="button"
                className={"btn btn-primary " + styles.btnSave}
                onClick={handleSave}
              >
                {labelSubmit}
              </button>
              <SweetAlert
                show={isSuccessSave}
                title="Sukses"
                text="Iklan berhasil diupdate"
                onConfirm={() => {
                  setIsSuccessSave(false);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditAdsForm;
